module.exports = {
    //application environment config goes here
    ROLLBAR: {
        accessToken: 'my-rollbar-access-token',
        enabled: false,
        payload: {environment: 'production'}
    }
};


// WEBPACK FOOTER //
// ./src/config/config.production.js